"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _templateObject;

var _excluded = ["onChange", "otherLabel", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectWithOther = void 0;

var react_1 = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var OTHER_VALUE = "__OTHER__";

var SelectWithOther = function SelectWithOther(_ref) {
  var onChange = _ref.onChange,
      otherLabel = _ref.otherLabel,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var selectRef = (0, react_1.useRef)();

  var _ref2 = (0, react_1.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      showOther = _ref3[0],
      setShowOther = _ref3[1];

  (0, react_1.useEffect)(function () {
    if (selectRef.current) {
      if (!Array.prototype.some.call(selectRef.current.options, function (opt) {
        return opt.value === String(props.value);
      })) {
        // if the current value does not exist within <options />,
        // we should select "Other" and show the value input
        setShowOther(true);
      }
    }
  }, [selectRef.current]);
  var onChangeSelectHandler = (0, react_1.useCallback)(function (e) {
    if (e.target.value === OTHER_VALUE) {
      setShowOther(true);
    } else {
      setShowOther(false);
      onChange(e);
    }
  }, [setShowOther, onChange]);
  return react_1.default.createElement(Container, null, react_1.default.createElement("select", _objectSpread(_objectSpread({
    ref: selectRef,
    onChange: onChangeSelectHandler
  }, props), {}, {
    value: showOther ? OTHER_VALUE : props.value
  }), children, react_1.default.createElement("option", {
    value: OTHER_VALUE
  }, otherLabel !== null && otherLabel !== void 0 ? otherLabel : "Other", ":")), showOther && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("input", _objectSpread({
    onChange: onChange,
    placeholder: props.type === "number" ? "123..." : "Aa..."
  }, props))));
};

exports.SelectWithOther = SelectWithOther;
var Container = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  select {\n    width: 30%;\n    max-width: 30%;\n  }\n  input {\n    flex-grow: 1;\n  }\n"])));